
import axios from './axiosConfig';
//import { createBrowserHistory } from "history";
//const API_URL = "https://api.demo1.raborisk.ai";
const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.demo1.raborisk.ai" 
    : "http://localhost:3000";



export const addProfileImage = (file) => {
    return (dispatch) => {
        const formData = new FormData();
        formData.append('file', file);

        axios.post(API_URL + "/api/user/add_profile_image", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(({ data }) => {
            dispatch({ type: "PROFILE_UPDATED", profile: data });
        })
        .catch(error => {
            console.error('Error uploading file:', error);
            dispatch({ type: "ERROR_MESSAGE", error_message: error.response.data.message });
        });
    };
};


    
export const resetProfileUpdated = () => {
    return (dispatch) => {
        dispatch({ type: "PROFILE_UPDATED_RESET", profile_updated: null });
    };
};

export const resetErrorMessage = () => {
    return (dispatch) => {
        dispatch({ type: "ERROR_MESSAGE", error_message: null });
    };
};

export const updateProfile = (profile) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/user/update_profile/", profile)
            .then(({ data }) => {
                //alert("Settings updated");
                dispatch({ type: "PROFILE_UPDATED", profile: data });
            }).catch((error) => {   
                dispatch({ type: "ERROR_MESSAGE", error_message: error.response.data.message });
            });
    };
};

export const getProfile = () => {
    return (dispatch) => {
        axios.get(API_URL + "/api/user/get_profile/")
            .then(({ data }) => {
                dispatch({ type: "PROFILE", profile: data });
            });
    };
};

export const changePassword = (passwords) => {
    return (dispatch) => {
        dispatch({ type: "RESET_ERROR_MESSAGE" });
        axios.post(API_URL + "/api/user/change_password", passwords)
            .then(({ data }) => {
                dispatch({ type: "PROFILE_UPDATED", profile: data });
            })
            .catch((error) => {
                const errorMessage = error.response?.data?.message || "Failed to change password";
                dispatch({ type: "ERROR_MESSAGE", error_message: errorMessage });
            });
    };
};

export const sendPasswordReset = (email) => {
    return (dispatch) => {
        dispatch({ type: "RESET_ERROR_MESSAGE" });
        axios.post(API_URL + "/api/auth/recovery", { email })
            .then(({ data }) => {
                dispatch({ type: "PROFILE_UPDATED", profile: data });
            })
            .catch((error) => {
                const errorMessage = error.response?.data?.message || "Failed to send password reset link";
                dispatch({ type: "ERROR_MESSAGE", error_message: errorMessage });
            });
    };
};